import React, { useState, useEffect } from "react";

const CountdownTimer = ({
  color= 'white',
  date
}) => {
  const [day, month, year] = date.split("/");
  const dateConverted = new Date(`${year}-${month}-${day}`);
  const formatted = dateConverted.toISOString().split("T")[0] + "T00:00:00";
  const targetDate = new Date(formatted).getTime();
  const [timeLeft, setTimeLeft] = useState(targetDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(targetDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval); // Nettoyage à la suppression du composant
  }, [targetDate]);

  // Conversion en jours, heures, minutes, secondes
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  return (
    <div style={styles.container}>
      {/* <h2>Diffusion l e 19 Mars à 21h15</h2> */}
      <div style={styles.timer}>
        <div style={{ color: color === "white" ? "#fff" : "#333", ...styles.timeBox }}>
          <span style={styles.number}>{days}</span>
          <span style={styles.word}>J</span>
        </div>
        <div style={{ color: color === "white" ? "#fff" : "#333", ...styles.timeBox }}>
          <span style={styles.number}>{hours}</span>
          <span style={styles.word}>H</span>
        </div>
        
        <div style={{ color: color === "white" ? "#fff" : "#333", ...styles.timeBox }}>
          <span style={styles.number}>{minutes}</span>
          <span style={styles.word}>M</span>
        </div>
        <div style={{ color: color === "white" ? "#fff" : "#333", ...styles.timeBox }}>
          <span style={styles.number}>{seconds}</span>
          <span style={styles.word}>S</span>
        </div>
      </div>
    </div>
  );
};

// Styles en objet (ou tu peux utiliser un fichier CSS)
const styles = {
  container: {
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  timer: {
    display: "flex",
    justifyContent: "center",
    gap: "5px",
    fontSize: "18px",
  },
  timeBox: {
    display: "flex",
    // justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    // padding: "5px",
    // borderRadius: "5px",
    // backgroundColor: "#FFF",
    // border: "1px solid #333",
    
    minWidth: "40px",
  },
  number: {
    fontSize: "18px",
    // fontWeight: "bold",
    display: "block",
    width: '20px',
  },
  word: {
    fontSize: "12px",
    fontWeight: 0,
    marginLeft: "2px",    
  }
};

export default CountdownTimer;
